<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            :showAddButton=false
            @handleAddNew="addNewAbsenteeism"
            :searchFilters="searchFilters"
            @searchPage="searchAbsenteeism"
            @resetFilters="resetFilters"
            @removeItem="removeAbsenteeism"
            @removeSelectedItems="removeAbsenteeisms"
            @printList="printCasesList"
            @printExcel="downloadCasesExcel"
            @printCSV="downloadCasesCSV"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="absentList"
            :actions="actions"
            :showActions=false
            :idField="idField"
            :groupingKey=true
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveAbsenteeism" @handleReset="handleReset"
            />
        </MovableModal>
        <MovableModal v-model:visible="transModalVisible" :title="transTitle" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="trans_modal_loader" @showLoader="showTransModalLoader" @hideLoader="hideTransModalLoader" @closeModal="closeTransModal">
            <DynamicForm 
                :fields="formFields1" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="approveAbsenteeism" @handleReset="handleReset1"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import PrintJS from 'print-js';

export default{
    name: 'Employee_Absenteeism',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const { getYear } = useDateFormatter();
        const { getMonth } = useDateFormatter();
        const current_date = new Date();
        const loader = ref('none');
        const modal_loader = ref('none');
        const trans_modal_loader = ref('none');
        const emplComponentKey = ref(0);
        const levComponentKey = ref(0);
        const lvComponentKey = ref(0);
        const idField = 'employee_absenteeism_id';
        const addButtonLabel = ref('New Absenteeism');
        const addingRight = ref('Adding Absenteeism');
        const removingRight = ref('Deleting Absenteeism');
        const rightsModule = ref('HR');
        const title = ref('Absenteeism Details');
        const transTitle = ref('Approve Absenteeism'); 
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const absentList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const transModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('500px');
        const modal_width = ref('30vw');
        const absenteeismID = ref('');
        const employeeID = ref('');
        const policyID = ref('');
        const leaveID = ref(null);
        const isEditing = computed(()=> store.state.Employee_Absenteeism.isEditing);
        const selectedAbsent = computed(()=> store.state.Employee_Absenteeism.selectedAbsent);
        const selectedPolicy = computed(()=> store.state.Employee_Absenteeism.selectedPolicy);
        const selectedEmployee = computed(()=> store.state.Employee_Absenteeism.selectedEmployee);
        const absentArray = computed(() => store.state.Absenteeism.absentArr);
        const employeeArray = computed(() => store.state.Employees.employeeArr);
        const leaveArray = computed(() => store.state.Leave_Types.leaveArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Staff No", key: "staff_number"},
            {label: "Employee Name", key: "employee_name"},
            {label: "Absenteeism", key: "absenteeism_name"},
            {label: "Month", key: "month"},
            {label: "Year", key: "year"},
            {label: "Days", key: "days"},
            {label: "Hours", key: "hours"},
            {label: "Mins", key: "minutes"},
            {label: "Description", key: "description"},
            {label: "Leave Type", key: "leave_type"},
            {label: "Appr. Status", key: "approval_status", textColor: "statusColor"},
            {label: "Approved By", key: "approved_by"},
            
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Absenteeism', rightName: 'Editing Absenteeism'},
            {name: 'approve/reject', icon: 'fa fa-check-circle', title: 'Approve/Reject Absenteeism', rightName: 'Approving Employee Absenteeism'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Absenteeism', rightName: 'Deleting Absenteeism'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const employee_name_search = ref('');
        const staff_number_search = ref('');
        const from_date_search = ref('');
        const to_date_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:32,},
            {type:'text', placeholder:"Employee Name...", value: employee_name_search, width:64,},
            {type:'date', placeholder:"From Date...", value: from_date_search, width:32,},
            {type:'date', placeholder:"To Date...", value: to_date_search, width:32,},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchEmployees = async() =>{
            await store.dispatch('Employees/fetchEmployees', {company:companyID.value});
        };
        const handleSelectedEmployee = async(option) =>{
            await store.dispatch('Employees/handleSelectedEmployee', option)
            employeeID.value = store.state.Employees.employeeID;
        };
        const clearSelectedEmployee = async() =>{
            await store.dispatch('Employees/updateState', {employeeID: ''});
            employeeID.value = store.state.Employees.employeeID;
        };
        const fetchAbsenteeism = async() =>{
            await store.dispatch('Absenteeism/fetchAbsenteeisms', {company:companyID.value});
        };
        const handleSelectedAbsenteeism = async(option) =>{
            await store.dispatch('Absenteeism/handleSelectedAbsenteeism', option)
            policyID.value = store.state.Absenteeism.absentID;
        };
        const clearSelectedAbsenteeism = async() =>{
            await store.dispatch('Absenteeism/updateState', {absentID: ''});
            policyID.value = store.state.Absenteeism.absentID;
        };
        const formFields = ref([]);

        const employeeValue = computed(() => {
           return (selectedAbsent.value && selectedAbsent.value.employee && !employeeID.value) ? selectedAbsent.value.employee.employee_id : employeeID.value;

        });

        const policyValue = computed(() => {
           return (selectedAbsent.value && selectedAbsent.value.absenteeism && !policyID.value) ? selectedAbsent.value.absenteeism.absenteeism_id : policyID.value;

        });
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Employee", value: employeeValue.value, componentKey: emplComponentKey,
                    selectOptions: employeeArray, optionSelected: handleSelectedEmployee, required: true,
                    searchPlaceholder: 'Select Employee...', dropdownWidth: '500px', updateValue: selectedEmployee.value,
                    clearSearch: clearSelectedEmployee
                },
                {  
                    type:'search-dropdown', label:"Absenteeism", value: policyValue.value, componentKey: levComponentKey,
                    selectOptions: absentArray, optionSelected: handleSelectedAbsenteeism, required: true,
                    searchPlaceholder: 'Select Absenteeism...', dropdownWidth: '500px', updateValue: selectedPolicy.value,
                    clearSearch: clearSelectedAbsenteeism
                },
                { type: 'date', name: 'date',label: "Date", value: selectedAbsent.value?.date, required: true },
                { type: 'number', name: 'days',label: "Days", value: selectedAbsent.value?.days || 0, required: false }, 
                { type: 'number', name: 'hours',label: "Hours", value: selectedAbsent.value?.hours || 0, required: false }, 
                { type: 'number', name: 'minutes',label: "Minutes", value: selectedAbsent.value?.minutes || 0, required: false }, 
                { type: 'dropdown', name: 'charge_mode',label: "Charge Mode", value:  selectedAbsent.value?.charge_mode || 'Salary', placeholder: "", required: true, options: [{ text: 'Salary', value: 'Salary' }, { text: 'Leave', value: 'Leave' }] },
                { type: 'dropdown', name: 'month',label: "Month", value: selectedAbsent.value?.month || getMonth(current_date), placeholder: "", required: true, options: [{ text: 'January', value: 'January' }, { text: 'February', value: 'February' },{ text: 'March', value: 'March' }, { text: 'April', value: 'April' },{ text: 'May', value: 'May' }, { text: 'June', value: 'June' },{ text: 'July', value: 'July' }, { text: 'August', value: 'August' },{ text: 'September', value: 'September' }, { text: 'October', value: 'October' },{ text: 'November', value: 'November' }, { text: 'December', value: 'December' }] },
                { type: 'text', name: 'year',label: "Year", value: selectedAbsent.value?.year || getYear(current_date), required: true},
                {type:'text-area', label:"Description", value: selectedAbsent.value?.description || '', textarea_rows: '4', textarea_cols: '56', required: false},                                                                        
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            levComponentKey.value += 1;
            policyID.value = '';
            emplComponentKey.value += 1;
            employeeID.value = '';
        }


        watch([selectedAbsent, selectedEmployee, selectedPolicy], () => {
            if (selectedAbsent.value && selectedEmployee.value && selectedPolicy.value) {
                levComponentKey.value += 1;
                emplComponentKey.value += 1;
                updateFormFields();
            }
            
        }, { immediate: true });
        
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createEmployeeAbsenteeism = async() =>{
            showModalLoader();
            let formData = {
                date: formFields.value[2].value,
                description: formFields.value[9].value,
                days: formFields.value[3].value,
                month: formFields.value[7].value,
                year: formFields.value[8].value,
                hours: formFields.value[4].value,
                minutes: formFields.value[5].value,
                charge_mode: formFields.value[6].value,
                approval_status: "Pending",
                approved_by: null,
                absenteeism: policyID.value,
                absenteeism_id: policyID.value,
                employee: employeeID.value,
                employee_id: employeeID.value,
                leave_type: null,
                leave_type_id: null,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(policyValue.value == '' || employeeValue.value == ''){
                errors.value.push('error')
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Employee_Absenteeism/createEmployeeAbsenteeism', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Absenteeism created successfully!');
                        handleReset();
                        emplComponentKey.value += 1;
                        levComponentKey.value += 1;
                    }
                    else {
                        toast.error('An error occurred while creating the Absenteeism.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Absenteeism: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchAbsenteeism();
                }
            }
        }
        const updateEmployeeAbsenteeism = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                employee_absenteeism: selectedAbsent.value.employee_absenteeism_id,
                date: formFields.value[2].value,
                description: formFields.value[9].value,
                days: formFields.value[3].value,
                month: formFields.value[7].value,
                year: formFields.value[8].value,
                hours: formFields.value[4].value,
                minutes: formFields.value[5].value,
                charge_mode: formFields.value[6].value,
                approval_status: selectedAbsent.value.approval_status,
                approved_by: selectedAbsent.value.approved_by,
                absenteeism: policyValue.value,
                absenteeism_id: policyValue.value,
                employee: employeeValue.value,
                employee_id: employeeValue.value,
                leave_type: null,
                leave_type_id: null,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown'  && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(policyValue.value == '' || employeeValue.value == ''){
                errors.value.push('error')
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Employee_Absenteeism/updateEmployeeAbsenteeism', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        emplComponentKey.value += 1;
                        toast.success("Absenteeism updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Absenteeism.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Absenteeism: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Employee_Absenteeism/updateState",{selectedAbsent:null})
                    searchAbsenteeism();
                }             
            }
        }
        const saveAbsenteeism = () =>{
            if(isEditing.value == true){
                updateEmployeeAbsenteeism();
            }else{
                createEmployeeAbsenteeism();
            }
        }
        const removeAbsenteeism = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    employee_absenteeism: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Employee_Absenteeism/deleteEmployeeAbsenteeism',formData)
                    if(response && response.status == 200){
                        toast.success("Absenteeism Removed Succesfully");
                        searchAbsenteeism();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Absenteeism: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Absenteeism") 
            }else{
                toast.error("Please Select An Absenteeism To Remove")
            }
        }
        const removeAbsenteeisms = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    employee_absenteeism: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Employee_Absenteeism/deleteEmployeeAbsenteeism',formData)
                    if(response && response.status == 200){
                        toast.success("Absenteeism(s) Removed Succesfully");
                        searchAbsenteeism();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Absenteeism: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select An Absenteeism To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchAbsenteeism = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                date_from: from_date_search.value,
                date_to: to_date_search.value,
                user: userID.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/employee-absenteeisms-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                absentList.value = response.data.results;
                store.commit('Employee_Absenteeism/LIST_ABSENTEEISM', absentList.value)
                propResults.value = response.data;
                propArrLen.value = absentList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchAbsenteeism(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            staff_number_search.value = "";
            employee_name_search.value = "";
            from_date_search.value = "";
            to_date_search.value = "";
            searchAbsenteeism();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchAbsenteeism();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchAbsenteeism();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchAbsenteeism();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchAbsenteeism();
            // scrollToTop();
        }
        const addNewAbsenteeism = () =>{
            store.dispatch("Employee_Absenteeism/updateState",{selectedAbsent:null,selectedEmployee:null,selectedPolicy:null});
            emplComponentKey.value += 1;
            levComponentKey.value += 1;
            handleReset();
            updateFormFields();
            propModalVisible.value = true;
            store.dispatch("Employee_Absenteeism/updateState",{isEditing:false})
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.333';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const advanceID = row['employee_absenteeism_id'];
                const approvalStatus = row['approval_status'];
                if(approvalStatus == "Pending"){
                    let formData = {
                        company: companyID.value,
                        employee_absenteeism: advanceID
                    }
                    await store.dispatch('Employee_Absenteeism/fetchEmployeeAbsenteeism',formData)
                    propModalVisible.value = true;
                    flex_basis.value = '1/3';
                    flex_basis_percentage.value = '33.333';
                }else{
                    toast.error(`Cannot Edit ${approvalStatus} Absenteeism`)
                }
                

            }else if(action == 'delete'){
                const absentID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    employee_absenteeism: absentID
                }
                await store.dispatch('Employee_Absenteeism/deleteEmployeeAbsenteeism',formData).
                then(()=>{
                    searchAbsenteeism();
                })
            }else if(action == 'approve/reject'){
                const applicationStatus = row['approval_status'];
                const chargeMode = row['charge_mode'];
                if(applicationStatus == 'Pending'){
                    updateFormFields1();
                    absenteeismID.value = row['employee_absenteeism_id'];
                    transModalVisible.value = true;
                    flex_basis.value = '1/3';
                    flex_basis_percentage.value = '33.333';
                    if (chargeMode == 'Leave'){
                        fetchLeaveTypes();
                        formFields1.value[1].hidden = false;
                    }else{
                        formFields1.value[1].hidden = true;
                    }
                }else{
                    toast.error(`Absenteeism Already ${applicationStatus}`)
                }
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printCasesList = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
            } 

            axios
            .post("api/v1/export-disciplinary-meetings-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data]);
                        // Convert blob to URL
                        const url = URL.createObjectURL(blob1);
                        PrintJS({printable: url, type: 'pdf'});
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadCasesExcel = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                status: status_search.value,
                company_id: companyID.value,
            }
            axios.post("api/v1/export-disciplinary-meetings-excel/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Disciplinary Meetings.xlsx');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadCasesCSV = () =>{
            showLoader();
            let formData = {
                employee_name: employee_name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
            }
            axios.post("api/v1/export-disciplinary-meetings-csv/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Disciplinary Meetings.csv');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const fetchLeaveTypes = async() =>{
            await store.dispatch('Leave_Types/fetchLeaveTypes', {company:companyID.value});
        };
        const handleSelectedLeave = async(option) =>{
            await store.dispatch('Leave_Types/handleSelectedLeaveType', option)
            leaveID.value = store.state.Leave_Types.leaveID;
            
        };
        const clearSelectedLeave = async() =>{
            await store.dispatch('Leave_Types/updateState', {leaveID: ''});
            leaveID.value = null;
        };
        const formFields1 = ref([]);
        const updateFormFields1 = () => {
            formFields1.value = [
                { type: 'dropdown', name: 'approval_status',label: "Status", value: '', placeholder: "", required: true, options: [{ text: 'Approve', value: 'Approved' }, { text: 'Reject', value: 'Rejected' }] },
                {  
                    type:'search-dropdown',label:"Leave Type", value: leaveID.value, componentKey: lvComponentKey,
                    selectOptions: leaveArray, optionSelected: handleSelectedLeave,
                    searchPlaceholder: 'Select Leave Type...', dropdownWidth: '400px',
                    clearSearch: clearSelectedLeave
                },
            ]
        };
        const handleReset1 = () =>{
            for(let i=0; i < formFields1.value.length; i++){
                formFields1.value[i].value = '';
            }
            lvComponentKey.value += 1;
            leaveID.value = null;
        };
        const showTransModalLoader = () =>{
            trans_modal_loader.value = "block";
        }
        const hideTransModalLoader = () =>{
            trans_modal_loader.value = "none";
        }
        const approveAbsenteeism = async() =>{
            showTransModalLoader();
            let formData = {
                employee_absenteeism: absenteeismID.value,
                approved_by: userID.value,
                approval_status: formFields1.value[0].value,
                leave_type: leaveID.value,
                company: companyID.value
            }

            axios.post(`api/v1/approve-employee-absenteeism/`,formData)
            .then((response)=>{
            if(response.data.msg == "Success"){
                hideTransModalLoader();
                closeTransModal();
                toast.success("Success")
                searchAbsenteeism();
            }else{
                toast.error("Error");
                hideTransModalLoader();
            }                   
            })
            .catch((error)=>{
                toast.error(error.message);
                hideTransModalLoader();
            })
        };
        const closeTransModal = () =>{
            transModalVisible.value = false;
            absenteeismID.value = null;
            hideTransModalLoader();
        };
        onBeforeMount(()=>{
            searchAbsenteeism();
            fetchEmployees();
            fetchAbsenteeism();
        })
        return{
            title, searchAbsenteeism,resetFilters, addButtonLabel, searchFilters, tableColumns, absentList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewAbsenteeism, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveAbsenteeism, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeAbsenteeism, removeAbsenteeisms,addingRight,removingRight,rightsModule,printCasesList,selectSearchQuantity,selectedValue,
            downloadCasesCSV,downloadCasesExcel,trans_modal_loader,transTitle,transModalVisible,showTransModalLoader,hideTransModalLoader,closeTransModal,
            approveAbsenteeism,formFields1,handleReset1
        }
    }
};
</script>